// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const getBaseApiUrl = () => {
  switch (document.location.hostname) {
    case 'localhost':
      return 'https://m-services-demo.gofileroom.com/api/';
      break;
    case 'demo.gofileroom.com':
    case 'member-demo.gofileroom.com':
    case 'member2-demo.gofileroom.com':
      return 'https://m-services-demo.gofileroom.com/api/';
      break;
    case 'ci.gofileroom.com':
    case 'member-ci.gofileroom.com':
    case 'member2-ci.gofileroom.com':
      return 'https://m-services-ci.gofileroom.com/api/';
      break;
    case 'qed.gofileroom.com':
    case 'member-qed.gofileroom.com':
    case 'member2-qed.gofileroom.com':
      return 'https://m-services-qed.gofileroom.com/api/';
      break;
    case 'ukqed.gofileroom.com':
    case 'member-ukqed.gofileroom.com':
    case 'member2-ukqed.gofileroom.com':
      return 'https://m-services-ukqed.gofileroom.com/api/';
      break;
    case 'gofileroom.com':
    case 'www.gofileroom.com':
    case 'member.gofileroom.com':
    case 'member2.gofileroom.com':
      return 'https://m-services.gofileroom.com/api/';
      break;
    case 'uk.gofileroom.com':
    case 'member-uk.gofileroom.com':
    case 'member2-uk.gofileroom.com':
      return 'https://m-services-uk.gofileroom.com/api/';
      break;
  }
};


export const environment = {

  production: true,
  base_api_uri: getBaseApiUrl(),

    environmentName:
    document.location.hostname === 'qa.gofileroom.com' ? 'qa'
    : document.location.hostname === 'demo.gofileroom.com' ? 'demo'
    : document.location.hostname === 'ci.gofileroom.com' ? 'ci'
    : document.location.hostname === 'localhost' ? 'localhost'
    :'',

    base_documents_api_uri:
     document.location.hostname === 'demo.gofileroom.com' ? 'https://m-services-demo.gofileroom.com/api/'
    : document.location.hostname === 'ci.gofileroom.com' ? 'https://m-services-ci.gofileroom.com/api/'
    : document.location.hostname === 'qed.gofileroom.com' ? 'https://m-services-qed.gofileroom.com/api/'
    : document.location.hostname === 'ukqed.gofileroom.com' ? 'https://m-services-ukqed.gofileroom.com/api/'
    : document.location.hostname === 'www.gofileroom.com' ? 'https://m-services.gofileroom.com/api/'
    : document.location.hostname === 'gofileroom.com' ? 'https://m-services.gofileroom.com/api/'
    : document.location.hostname === 'uk.gofileroom.com' ? 'https://m-services-uk.gofileroom.com/api/'
    : document.location.hostname === 'member-ci.gofileroom.com' ? 'https://m-services-ci.gofileroom.com/api/'
    : document.location.hostname === 'member2-ci.gofileroom.com' ? 'https://m-services-ci.gofileroom.com/api/'
    : document.location.hostname === 'member-demo.gofileroom.com' ? 'https://m-services-demo.gofileroom.com/api/'
    : document.location.hostname === 'member2-demo.gofileroom.com' ? 'https://m-services-demo.gofileroom.com/api/'
    : document.location.hostname === 'member-qed.gofileroom.com' ? 'https://m-services-qed.gofileroom.com/api/'
    : document.location.hostname === 'member2-qed.gofileroom.com' ? 'https://m-services-qed.gofileroom.com/api/'
    : document.location.hostname === 'member-ukqed.gofileroom.com' ? 'https://m-services-ukqed.gofileroom.com/api/'
    : document.location.hostname === 'member2-ukqed.gofileroom.com' ? 'https://m-services-ukqed.gofileroom.com/api/'
    : document.location.hostname === 'member-uk.gofileroom.com' ? 'https://m-services-uk.gofileroom.com/api/'
    : document.location.hostname === 'member2-uk.gofileroom.com' ? 'https://m-services-uk.gofileroom.com/api/'
    : document.location.hostname === 'member.gofileroom.com' ? 'https://m-services.gofileroom.com/api/'
    : document.location.hostname === 'member2.gofileroom.com' ? 'https://m-services.gofileroom.com/api/'
    :'https://m-services.gofileroom.com/api/',

    base_dashboard_api_uri:
     document.location.hostname === 'demo.gofileroom.com' ? 'https://dashboard-services-demo.gofileroom.com/api/v1'
    : document.location.hostname === 'ci.gofileroom.com' ? 'https://dashboard-services-ci.gofileroom.com/api/v1'
    : document.location.hostname === 'qed.gofileroom.com' ? 'https://dashboard-services-qed.gofileroom.com/api/v1'
    : document.location.hostname === 'ukqed.gofileroom.com' ? 'https://dashboard-services-ukqed.gofileroom.com/api/v1'
    : document.location.hostname === 'www.gofileroom.com' ? 'https://dashboard-services.gofileroom.com/api/v1'
    : document.location.hostname === 'gofileroom.com' ? 'https://dashboard-services.gofileroom.com/api/v1'
    : document.location.hostname === 'uk.gofileroom.com' ? 'https://dashboard-services-uk.gofileroom.com/api/v1'
    : document.location.hostname === 'member-ci.gofileroom.com' ? 'https://dashboard-services-ci.gofileroom.com/api/v1'
    : document.location.hostname === 'member2-ci.gofileroom.com' ? 'https://dashboard-services-ci.gofileroom.com/api/v1'
    : document.location.hostname === 'member-demo.gofileroom.com' ? 'https://dashboard-services-demo.gofileroom.com/api/v1'
    : document.location.hostname === 'member2-demo.gofileroom.com' ? 'https://dashboard-services-demo.gofileroom.com/api/v1'
    : document.location.hostname === 'member-qed.gofileroom.com' ? 'https://dashboard-services-qed.gofileroom.com/api/v1'
    : document.location.hostname === 'member2-qed.gofileroom.com' ? 'https://dashboard-services-qed.gofileroom.com/api/v1'
    : document.location.hostname === 'member-ukqed.gofileroom.com' ? 'https://dashboard-services-ukqed.gofileroom.com/api/v1'
    : document.location.hostname === 'member2-ukqed.gofileroom.com' ? 'https://dashboard-services-ukqed.gofileroom.com/api/v1'
    : document.location.hostname === 'member-uk.gofileroom.com' ? 'https://dashboard-services-uk.gofileroom.com/api/v1'
    : document.location.hostname === 'member2-uk.gofileroom.com' ? 'https://dashboard-services-uk.gofileroom.com/api/v1'
    : document.location.hostname === 'member.gofileroom.com' ? 'https://dashboard-services.gofileroom.com/api/v1'
    : document.location.hostname === 'member2.gofileroom.com' ? 'https://dashboard-services.gofileroom.com/api/v1'
    :'https://dashboard-services.gofileroom.com/api/v1',

    

    strrooturl:
      document.location.hostname === 'demo.gofileroom.com' ? 'https://demo.gofileroom.com/'
    : document.location.hostname === 'ci.gofileroom.com' ? 'https://ci.gofileroom.com/'
    : document.location.hostname === 'qed.gofileroom.com' ? 'https://qed.gofileroom.com/'
    : document.location.hostname === 'ukqed.gofileroom.com' ? 'https://ukqed.gofileroom.com/'
    : document.location.hostname === 'www.gofileroom.com' ? 'https://www.gofileroom.com/'
    : document.location.hostname === 'gofileroom.com' ? 'https://www.gofileroom.com/'
    : document.location.hostname === 'uk.gofileroom.com' ? 'https://uk.gofileroom.com/'
    : document.location.hostname === 'member-ci.gofileroom.com' ? 'https://member-ci.gofileroom.com/'
    : document.location.hostname === 'member2-ci.gofileroom.com' ? 'https://member2-ci.gofileroom.com/'
    : document.location.hostname === 'member-demo.gofileroom.com' ? 'https://member-demo.gofileroom.com/'
    : document.location.hostname === 'member2-demo.gofileroom.com' ? 'https://member2-demo.gofileroom.com/'
    : document.location.hostname === 'member-qed.gofileroom.com' ? 'https://member-qed.gofileroom.com/'
    : document.location.hostname === 'member2-qed.gofileroom.com' ? 'https://member2-qed.gofileroom.com/'
    : document.location.hostname === 'member-ukqed.gofileroom.com' ? 'https://member-ukqed.gofileroom.com/'
    : document.location.hostname === 'member2-ukqed.gofileroom.com' ? 'https://member2-ukqed.gofileroom.com/'
    : document.location.hostname === 'member-uk.gofileroom.com' ? 'https://member-uk.gofileroom.com/'
    : document.location.hostname === 'member2-uk.gofileroom.com' ? 'https://member2-uk.gofileroom.com/'
    : document.location.hostname === 'member.gofileroom.com' ? 'https://member.gofileroom.com/'
    : document.location.hostname === 'member2.gofileroom.com' ? 'https://member2.gofileroom.com/'
    :'https://www.gofileroom.com/',

    base_workflows_api_uri:
    document.location.hostname === 'demo.gofileroom.com' ? 'https://firmflow-api-demo.gofileroom.com/api/'
    : document.location.hostname === 'ci.gofileroom.com' ? 'https://firmflow-api-ci.gofileroom.com/api/'
    : document.location.hostname === 'qed.gofileroom.com' ? 'https://firmflow-api-qed.gofileroom.com/api/'
    : document.location.hostname === 'ukqed.gofileroom.com' ? 'https://firmflow-api-ukqed.gofileroom.com/api/'
    : document.location.hostname === 'www.gofileroom.com' ? 'https://firmflow-api.gofileroom.com/api/'
    : document.location.hostname === 'gofileroom.com' ? 'https://firmflow-api.gofileroom.com/api/'
    : document.location.hostname === 'uk.gofileroom.com' ? 'https://firmflow-api-uk.gofileroom.com/api/'
    : document.location.hostname === 'member-ci.gofileroom.com' ? 'https://firmflow-api-ci.gofileroom.com/api/'
    : document.location.hostname === 'member2-ci.gofileroom.com' ? 'https://firmflow-api-ci.gofileroom.com/api/'
    : document.location.hostname === 'member-demo.gofileroom.com' ? 'https://firmflow-api-demo.gofileroom.com/api/'
    : document.location.hostname === 'member2-demo.gofileroom.com' ? 'https://firmflow-api-demo.gofileroom.com/api/'
    : document.location.hostname === 'member-qed.gofileroom.com ' ? 'https://firmflow-api-qed.gofileroom.com/api/'
    : document.location.hostname === 'member2-qed.gofileroom.com ' ? 'https://firmflow-api-qed.gofileroom.com/api/'
    : document.location.hostname === 'member-ukqed.gofileroom.com ' ? 'https://firmflow-api-ukqed.gofileroom.com/api/'
    : document.location.hostname === 'member2-ukqed.gofileroom.com ' ? 'https://firmflow-api-ukqed.gofileroom.com/api/'
    : document.location.hostname === 'member-uk.gofileroom.com ' ? 'https://firmflow-api-uk.gofileroom.com/api/'
    : document.location.hostname === 'member2-uk.gofileroom.com ' ? 'https://firmflow-api-uk.gofileroom.com/api/'
    : document.location.hostname === 'member.gofileroom.com ' ? 'https://firmflow-api.gofileroom.com/api/'
    : document.location.hostname === 'member2.gofileroom.com ' ? 'https://firmflow-api.gofileroom.com/api/'
    : 'https://firmflow-api.gofileroom.com/api/',

    defaultTimeOutValue: 30
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
